import './style.scss'

import React, { Component } from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'

class ButtonRow extends Component {
    render() {
        const { className, children, style } = this.props
        const styleClass = style ? style : null
        const classes = classNames({
            'button-row': true,
            [`button-row--${styleClass}`]: styleClass,
            [`${className}`]: className,
        })
        return <div className={classes}>{children}</div>
    }
}

ButtonRow.propTypes = {
    children: PropTypes.node,
    style: PropTypes.oneOf(['bordered', 'centered', 'full-size', 'stacked', 'equal']),
    className: PropTypes.string,
}

export default ButtonRow
